import Component from '../core/Component'
import SectionObserver from './SectionObserver'
import EventBus from '../core/EventBus'
import { EVENTS } from '../core/Events'

export default class SectionGalleryList extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            links: [],
        }
    }

    prepare() {
        this.sectionObserver = new SectionObserver(document.createElement('div'))
        EventBus.on(EVENTS.SECTIONOBSERVER_SECTIONCHANGE, this.handleSectionObserverSectionChange)
        this.sectionObserver.prepare()
    }

    destroy() {
        if (this.sectionObserver) {
            this.sectionObserver.destroy()
            EventBus.off(EVENTS.SECTIONOBSERVER_SECTIONCHANGE, this.handleSectionObserverSectionChange)
        }
    }

    handleSectionObserverSectionChange = event => {
        const sectionsInViewport = event.sectionsInViewport
        if (sectionsInViewport.length == 0) {
            this.select(0)
        } else {
            const mostVisibleSection = sectionsInViewport[0]
            this.select(this.findLinkIndexById(mostVisibleSection.element.id))
        }
    }

    findLinkIndexById(id) {
        return this.ref.links.findIndex((link) => link.href.split('#')[1] === id)
    }

    select(index) {
        if (this.index === index) {
            return
        }

        this.ref.links.forEach((link,_index) => {
            link.classList.toggle('is-active', index === _index)
        })
        const linkEl = this.ref.links[index]
        if (!linkEl) {
            return
        }

        this.index = index
    }
}